import { Injectable } from '@angular/core';
import markdownit from 'markdown-it'

@Injectable({
  providedIn: 'root'
})
export class MarkdownService {
  private readonly md = markdownit()

  constructor() { }

  html(markdown: string): string {
    return this.md.render(markdown)
  }
}
